import React, { useEffect, useRef, useState } from "react";
import { MessageCircle, PenTool, FileText, KeyRound, CheckCircle2 } from "lucide-react";
import { PROCESS_STEPS } from "../mock";

const ICONS = [MessageCircle, PenTool, FileText, KeyRound, CheckCircle2];

const Step = ({ step, index, isLast }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setInView(true),
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const Icon = ICONS[index];

  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${index * 80}ms` }}
      className={`relative flex gap-6 pb-10 fade-up ${inView ? "in-view" : ""}`}
    >
      {/* icon + connector */}
      <div className="relative flex flex-col items-center">
        <span className="w-14 h-14 rounded-none border-2 border-[#c79a5b] bg-white flex items-center justify-center shrink-0">
          <Icon size={22} className="text-[#c79a5b]" />
        </span>
        {!isLast && (
          <span className="w-px flex-1 bg-[#e0d8ca] mt-2" />
        )}
      </div>

      <div className="pt-1">
        <span className="block text-[13px] font-bold tracking-[0.3em] text-[#c79a5b]">
          {step.num}
        </span>
        <h3 className="font-heading mt-1 text-[22px] sm:text-[26px] font-bold text-[#1b2b45] leading-tight">
          {step.title}
        </h3>
        <p className="mt-1.5 text-[15px] text-[#6b7385] leading-relaxed max-w-xl">
          {step.desc}
        </p>
      </div>
    </div>
  );
};

const Process = () => {
  return (
    <section id="proces" className="py-20 md:py-28 bg-[#f7f4ee]">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <span className="eyebrow-line">Jak to probíhá</span>
        <h2 className="font-heading mt-5 mb-12 text-[30px] sm:text-[38px] md:text-[52px] font-bold text-[#1b2b45] leading-tight">
          Proces rekonstrukce
        </h2>
        <div>
          {PROCESS_STEPS.map((s, i) => (
            <Step
              key={s.num}
              step={s}
              index={i}
              isLast={i === PROCESS_STEPS.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
